import AnalyticsHelper from '../../utils/analytics-helper.js';
import Loader from '../modules/loader.js';
import Form from '../../form_builder_2/form.js';
import SelectedDealer from '../modules/selected-dealer.js';

export default class FormView {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.bas-form');
        this.back = this.el.querySelector('.back-link');
        this.tabs = this.el.querySelector('.bas-tabs');
        this.headings = this.el.querySelectorAll('.bas-tab-heading');
        this.loader = new Loader(this, router);
        this.callbacks = { 
            onSubmit: this.onSubmit.bind(this), 
            onSuccess: this.onSuccess.bind(this), 
            onError: this.onError.bind(this),
            onUpdate: this.onUpdate.bind(this),
        }
        this.form = new Form(this.el.querySelector('.form_builder'), this.callbacks);
        this.dealer = new SelectedDealer(this, this.router);
        this.bind();
    }

    bind() {
        this.back.addEventListener('click', (e) => {
            e.preventDefault();
            this.router.update('search');
        });

        this.headings.forEach((t) => t.addEventListener('click', (e) => {
            e.preventDefault();
            this.headings.forEach((h) => h.parentNode.classList.remove('active'));
            e.currentTarget.parentNode.classList.add('active');
        }));
    }

    onSubmit() {
        this.tabs.classList.add('hide');
        this.loader.show();
    }

    onSuccess() {
        this.loader.hide();
        this.tabs.classList.remove('hide');
        this.router.update('confirm');
    }

    onError() {
        this.loader.hide();
        this.tabs.classList.remove('hide');
        this.form.showError();
    }

    onUpdate(field, valid) {
        if(!this.updated) {
            this.updated = true;
            AnalyticsHelper.push({ 'event': 'Book a service', 'eventCategory':' Book a service', 'eventLabel': field.label, 'eventAction':'Form Filling Initiate' });
        }
        if(!valid) {
            AnalyticsHelper.push({ 'event': 'Book a service', 'eventCategory':' Book a service', 'eventLabel': field.label, 'eventAction':'Form Validation Error' });
        }
    }

    show() {
        if (!this.router.params.has('dealer')) {
            this.router.update('search');
        } else {
            this.el.classList.remove('hide');
            this.dealer.show();
            window.scrollTo(0,0);
            this.animate();
            
            AnalyticsHelper.template(this.back, { dealer: this.router.params.get('dealer') });
            this.headings.forEach((h) => AnalyticsHelper.template(h, { dealer: this.router.params.get('dealer') }));
            AnalyticsHelper.push(this.headings[0]);
        }
    }

    hide() {
        this.el.classList.add('hide');
    }

    animate() {
        this.el.classList.remove('pre-animation');
        this.el.classList.add('apply-animation');
    }
}
